import { CourseData } from "@/models/Course";

export interface CourseTabComponentProps {
  id: number;
  path: (string | number)[];
}

export interface CourseTabGroup {
  level: "chapters" | "lessons" | "steps";
  tabs: CourseTabData[];
}

export interface CourseTabData {
  id: number;
  index: number;
  title?: string;
  subIndex?: number; // For steps (conversations and questions)
  childrenType: string;

  tabList?: unknown;
  content?: unknown;
}

export const hasSubtabs = (data: CourseTabData): data is CourseTabDataWithSubtabs => {
  return data.childrenType === "subtabs";
};

export const hasContent = (data: CourseTabData): data is CourseTabDataWithContent => {
  return data.childrenType === "content";
};

export interface CourseTabDataWithSubtabs extends CourseTabData {
  childrenType: "subtabs";
  tabList: CourseTabGroup;
  titles?: string[];
  selectedTitle?: number;
  content?: undefined;
}

export interface CourseTabDataWithContent extends CourseTabData {
  childrenType: "content";
  content: CourseData.Step;
  tabList?: undefined;
}
